<template>
    <div>
        <el-tree
            ref="tree"
            :data="data"
            show-checkbox
            node-key="id"
            :props="defaultProps">
        </el-tree>
        <br>
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button @click="block">返回</el-button>
    </div>
</template>

<script>
    export default{
        data() {
            return {
                data: [],
                defaultProps: {
                    children: 'children',
                    label: 'label'
                },
                id:0,
            }
        },
        async created() {
            if(this.$route.params.id) {
                this.id = this.$route.params.id;
                await this.$http.get('/manage/perm/permAll').then(result=> {
                    this.data = result['data'];
                });
                this.$http.get('/manage/admin/getview/'+this.id).then(data => {
                    let keys = JSON.parse(data['data']['qx']);
                    this.$refs.tree.setCheckedKeys(keys);
                })
                // .catch(() => {
                //     this.$router.go(-1);
                // });
            }else {
                this.$router.go(-1);
            }
        },
        methods: {
            submit() {
                let params = {
                    id: this.id,
                    qx: this.$refs.tree.getCheckedKeys()
                };
                this.$http.post('/manage/admin/editgrants',params).then(result=> {
                    if(result.data == 'ok') {
                        this.$message({
                            message: '操作成功',
                            type: 'success'
                        });
                        this.$router.go(-1);
                    }else {
                        this.$message({
                            message: result.data,
                            type: 'error'
                        });
                    }
                })
            },
            block() {
                this.$router.push('/setting/admin');
            }
        },
    }
</script>